@if (isVisible) {
  <div class="chatbot-modal-backdrop"
    (click)="onBackdropClick($event)">
    <div class="chatbot-modal-content">
      @if (title || showCloseButton) {
        <div class="chatbot-modal-header">
          @if (title) {
            <h3 class="chatbot-modal-title">{{ title }}</h3>
          }
          @if (showCloseButton) {
            <button class="close-button"
              (click)="onClose()">
              &times;
            </button>
          }
        </div>
      }
      <div class="chatbot-modal-body">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
